var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{staticClass:"mb-3"},[(_vm.order.status === 'PENDING')?_c('v-layout',[_c('ActiveOrderItem',{attrs:{"order":_vm.order}})],1):_c('v-layout',[_c('ArchivedOrderItem',{attrs:{"order":_vm.order}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }